
export const dangerousPermissionsMixin = {

    data() {
        return {

            // Keep this in sync with config/permission.dangerous
            dangerousPermissions: [
                'export panelist',
                'export project participants',
                'export panelists',
                'view pi'
            ]
        }
    },

    methods: {

        getDangerousPermissions(permissions) {

            let dangerous = [];

            permissions.forEach(permission => {
                if (this.dangerousPermissions.includes(permission.name)) {
                    dangerous.push(permission.name);
                }
            })

            return dangerous;
        }
    }
}

